module.exports = __webpack_public_path__ + "img/android.44794266.svg";